import { ErrorCircle } from '@ori-ui/icons';
import { Button, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

import { ERROR_INFO } from './constants';
import { ButtonContainer, IconContainer, Root } from './styles';
import type { ErrorInfoProps } from './types';

export const ErrorInfo = ({ title, description, buttonTitle, handleButtonClick }: ErrorInfoProps) => {
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId(ERROR_INFO)}>
      <IconContainer>
        <ErrorCircle
          fontSize="inherit"
          color="inherit"
        />
      </IconContainer>
      <Typography
        variant="h4"
        color="inherit"
      >
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="inherit"
        textAlign="center"
      >
        {description}
      </Typography>
      <ButtonContainer>
        <Button
          key="accept"
          fullWidth
          color="primary"
          variant="contained"
          id="accept"
          onClick={handleButtonClick}
        >
          {buttonTitle}
        </Button>
      </ButtonContainer>
    </Root>
  );
};
